import { render } from "./UblTable.vue?vue&type=template&id=a19a0ad2&scoped=true"
import script from "./UblTable.vue?vue&type=script&lang=js"
export * from "./UblTable.vue?vue&type=script&lang=js"

import "./UblTable.vue?vue&type=style&index=0&id=a19a0ad2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a19a0ad2"]])

export default __exports__